module.exports = __webpack_public_path__ + "static/img/vote-count.69df5fc0.png";